import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles } from '../../core/style/gstheme';
import LabelLink from '../core/LabelLink';

const styles = Object.assign({}, globalStyles);

class FloatingLabelRelationshipLink extends React.Component {

    render() {

        const { id, defaultLang, link, onLink, isReadOnly, source, graph, target, property, updateEvent, propertyGraph, viewLang } = this.props;

        return (
            <LabelLink
                propertyGraph={propertyGraph}
                source={source}
                target={target}
                id={id}
                graph={graph}
                otherScheme={true}
                viewLang={viewLang}
                link={link}
                onLink={onLink}
                property={property}
                isReadOnly={isReadOnly}
                loadOptions={{
                    language: viewLang && viewLang !== defaultLang ? [defaultLang, viewLang] : defaultLang
                }}
                defaultLang={defaultLang}
                updateEvent={updateEvent} />
        );
    }
}

FloatingLabelRelationshipLink.propTypes = {
    link: PropTypes.string.isRequired,
    onLink: PropTypes.func,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    source: PropTypes.string,
    target: PropTypes.string,
    isReadOnly: PropTypes.bool,
    propertyGraph: PropTypes.string,
    property: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    updateEvent: PropTypes.func
};

export default withRouter(withStyles(styles)(FloatingLabelRelationshipLink));